/**
 * Launch hints for team @mentions (TEAM_MENTIONS_FEATURE). Everything here is shown only with the
 * flag on, once per person, and goes away after "Got it", after the person uses the feature, or
 * after 30 days (useDismissibleBanner's default TTL). Bump a key's version to show it again.
 */

export const MENTIONS_LAUNCH_KEYS = {
  /** Blue "New:" banner at the top of the chart notes list. */
  banner: "suno_mentions_launch_banner_v1_",
  /** Pulsing dot on the "@" toolbar button in chart note and task description editors. */
  editorButton: "suno_mentions_editor_button_hint_v1_",
  /** Pulsing dot on the task comment box. */
  commentBox: "suno_mentions_comment_hint_v1_",
  /** "NEW" chip on the bell's Mentions tab. */
  bellTab: "suno_mentions_bell_tab_new_v1_",
  /** One-time tip at the top of the bell's Mentions tab. */
  bellTip: "suno_mentions_bell_tip_v1_",
  /** "NEW" chip on Home → Tasks → Mentioned Me. */
  homeTab: "suno_mentions_home_tab_new_v1_"
} as const;

/** Someone picked a teammate in any @ picker: they've found the feature. */
export const MENTIONS_USED_EVENT = "suno:mentions-used";
/** Someone clicked the "@" toolbar button in an editor. */
export const MENTION_BUTTON_USED_EVENT = "suno:mention-button-used";

export const markMentionsUsed = () =>
  window.dispatchEvent(new Event(MENTIONS_USED_EVENT));

export const markMentionButtonUsed = () =>
  window.dispatchEvent(new Event(MENTION_BUTTON_USED_EVENT));

/** Set on <body> while the "@" button hint is due; word-processor.css draws the dot from it. */
export const MENTION_BUTTON_HINT_BODY_CLASS = "suno-mention-button-hint";

/** Personal settings, Notification Preferences tab, with the mention email checkbox highlighted. */
export const MENTION_EMAIL_SETTING_LINK =
  "/settings/personal?tab=notification-preferences&highlight=mention-email";
export const MENTION_EMAIL_HIGHLIGHT = "mention-email";
